/**
 * Get saved cookie if exists
 *
 * @param {string} name cookie name
 */
const getCookie = (name) => {
  const value = "; " + document.cookie;
  const parts = value.split("; " + name + "=");

  if (parts.length === 2) {
    return parts.pop().split(";").shift();
  }
  return null;
};

/**
 * Set value for cookie with given name with expiry time
 *
 * @param {string} name cookie name
 * @param {string} value cookie value to set
 * @param {string} days days until expiry of cookie
 */
const setCookie = (name, value, days) => {
  const expires = new Date();

  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie =
    name + "=" + value + ";expires=" + expires.toUTCString() + ";path=/";
};

/**
 * Script to init banner announcement and it's cookies
 *
 * @param {string} htmlContainerId banner container id
 * @param {string} htmlCloseButtonId banner close button container id
 */
const bannerAnnouncement = (htmlContainerId, htmlCloseButtonId) => {
  window.addEventListener("DOMContentLoaded", () => {
    const banner = document.getElementById(htmlContainerId);
    if (!banner) {
      return;
    }
    const closeButton = banner.querySelector(`#${htmlCloseButtonId}`);
    if (!closeButton) {
      return;
    }

    const bannerVersion = banner.dataset.version;
    const daysUntilExpiry = banner.dataset.daysUntilExpiry;
    const closedBannerVersion = getCookie("closedBannerVersion");

    if (
      !closedBannerVersion ||
      parseInt(closedBannerVersion) < parseInt(bannerVersion)
    ) {
      banner.style.display = "block";
    }

    closeButton.addEventListener("click", () => {
      banner.style.display = "none";
      setCookie("closedBannerVersion", bannerVersion, daysUntilExpiry);
    });
  });
};

bannerAnnouncement("banner-announcement", "banner-close-button");

export default bannerAnnouncement;
